<template>
  <div>
    <van-sticky>
      <navbar :title="title" />
      <van-search
        v-model="list.product_name"
        placeholder="请输入搜索关键词"
        @search="onSearch"
      ></van-search>
    </van-sticky>

    <van-list
      v-model="list.loading"
      :finished="list.finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <van-cell
        v-for="(item, index) in dataList"
        :key="index"
        @click="stockDetails(index)"
      >
        <div class="user-title">
          <span class="user-title-name" style="font-weight: 600">
            <van-icon name="apps-o" />
            {{ item.product_name }}
          </span>
          <span class="user-title-date" style="float: right">{{ item.remaining_inventory }}</span>
        </div>
      </van-cell>
    </van-list>

    <!-- <van-popup closeable class="popup-details" v-model="show">
      <van-collapse class="detail-content" v-model="activeNames">
        <van-collapse-item
          :title="details.product_name"
          :value="
            sufficient(
              details.total_quantity -
                details.ph_quantity -
                details.not_ph_quantity -
                details.order_quantity
            )
          "
          name="1"
          value-class="right-text"
        >
          <div class="body">
            <van-cell title="产品规格" :value="details.product_specification" />
            <van-cell title="最新单价(含税)" :value="details.qd_price" />
            <van-cell
              title="累计库存"
              :value="
                details.total_quantity -
                details.ph_quantity -
                details.not_ph_quantity
              "
            />
            <van-cell title="预出库数量" :value="details.order_quantity" />
            <van-cell
              title="可用数量"
              :value="
                details.total_quantity -
                details.ph_quantity -
                details.not_ph_quantity -
                details.order_quantity
              "
            />
            <van-cell title="剩余数量" :value="details.residue" />
          </div>
        </van-collapse-item>
      </van-collapse>
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <ul>
          <li class="tab-title">
            <span>批次号</span>
            <span>入库数量</span>
            <span>剩余数量</span>
          </li>
          <li class="tab-content">
            <span>fsk139</span>
            <span>139</span>
            <span>380</span>
          </li>
          <li class="tab-content">
            <span>fsk139</span>
            <span>139</span>
            <span>380</span>
          </li>
          <li class="tab-content">
            <span>fsk139</span>
            <span>139</span>
            <span>380</span>
          </li>
        </ul>
      </van-list>
    </van-popup> -->
  </div>
</template>

<script>
import navbar from "@/components/navBar/index";
import { post } from "@/api/stock";
import { Toast } from "vant";

export default {
  name: "signList",
  components: {
    navbar,
  },
  data() {
    return {
      title: "库存列表",
      list: {
        requestType: "product_stock_list",
        loading: false,
        finished: false,
        page: 1,
        limit: 20,
        product_name: "",
      },
      dataList: [],
      // activeNames: ["0"], //折叠面板
      // show: false,
      // details: {},
    };
  },
  methods: {
    onLoad() {
      post(this.list)
        .then((response) => {
          if (response.obj.rows.length === 0) {
            this.list.finished = true;
          }
          if (this.list.page != 1) {
            this.dataList = this.dataList.concat(response.obj.rows);
          } else {
            this.dataList = response.obj.rows;
          }

          this.list.page += 1;
          this.list.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.list.loading = false;
          this.list.finished = true;
          return Toast("数据异常");
        });
    },
    onSearch() {
      this.list.finished = false;
      this.list.page = 1;
      this.onLoad();
    },
    stockDetails(index) {
      // this.show = true;
      // this.details = this.dataList[index];
      this.$router.push({ name: "stockDetail", params: this.dataList[index] });
    },
    sufficient(num) {
      if (num > 0) {
        return "库存充足";
      } else {
        return "库存不足";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.right-text {
  color: red !important;
}
/deep/.van-collapse-item__content {
  padding: 0;
}
.van-tag + .van-tag {
  margin-left: 8px;
}
.popup-details {
  width: 100%;
  height: 100%;
}
.detail-content {
  margin-top: 50px;
}
.tab-title {
  padding-top: 20px;
  span {
    width: 33.33%;
    display: block;
    float: left;
    text-align: center;
    font-weight: bold;
    font-size: 13px;
  }
}
.tab-content {
  line-height: 30px;
  span {
    width: 33.33%;
    display: block;
    float: left;
    text-align: center;
  }
}
</style>
